import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { School } from '@tanzspass/shared';
import { SchoolService } from '../../services/school.service';
import { PictureComponent } from '../../shared/picture/picture.component';

@Component({
  selector: 'ts-room-teaser',
  templateUrl: './room-teaser.component.html',
  styleUrls: ['./room-teaser.component.css'],
  imports: [PictureComponent, NgIf, RouterLink],
})
export class RoomTeaserComponent implements OnInit {
  public school: School = new School();

  constructor(private schoolSrv: SchoolService) {}

  ngOnInit() {
    this.schoolSrv.current().subscribe((school) => {
      this.school = school;
    });
  }
}
